import { useState } from 'react';
import { Link } from 'react-router-dom';
import ApperIcon from '@/components/ApperIcon';
import { PlanCompare, useComparePlans } from '@/components/compare/PlanCompare';
import { BANSHEE_PATH, PLANS } from '@/shared/pricing';
import { useSeo } from '@/shared/seo';
import { GLOW, LABEL, WRAP } from '@/components/home/styles';
import { cn } from '@/lib/utils';

// Lives under the private Banshee address: invitation only, kept out of search and the sitemap.
export const route = { path: '/banshee-7x2q9k/compare', layout: 'public', access: 'public' };

const KEYS = ['Wraith', 'Demon', 'Banshee'];

export default function BansheeCompare() {
  const [conns, setConns] = useState(1);
  const { plans, ready } = useComparePlans(KEYS);

  useSeo({ title: 'Compare private packages', noindex: true });

  return (
    <div className={cn(WRAP, 'pb-24 pt-16 md:pt-24')}>
      <Link
        to={BANSHEE_PATH}
        className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary"
      >
        <ApperIcon name="ArrowLeft" size={14} />
        Back to {PLANS.Banshee.name}
      </Link>

      <p className={cn(LABEL, 'mt-8 flex items-center gap-2')}>
        <ApperIcon name="Lock" size={12} />
        Private comparison · invitation only
      </p>
      <h1 className="mt-4 text-[clamp(40px,7vw,88px)] font-light leading-[0.98]">
        {plans.map((p, i) => (
          <span key={p}>
            {i > 0 && <span className="text-muted-foreground">{i === plans.length - 1 ? ' and ' : ', '}</span>}
            <span className={cn('font-heading', GLOW)}>{PLANS[p].name}</span>
          </span>
        ))}
      </h1>
      <p className="mt-5 max-w-2xl text-lg text-foreground/85">
        Every Ghost Cable plan side by side, including the private {PLANS.Banshee.name} packages.
      </p>

      {ready ? (
        <div className="mt-16">
          <PlanCompare plans={plans} conns={conns} setConns={setConns} />
        </div>
      ) : (
        <div aria-busy="true" className="min-h-[60vh]" />
      )}

      <p className="mt-16 border-t border-border pt-8 text-xs text-muted-foreground">
        This page is private. Please don't share the link publicly.
      </p>
    </div>
  );
}
